import AmandaLewisPicSvg from "../../assets/whyDevfest/amanda-lewis-stylized.svg";
import ThomasEzanPicSvg from "../../assets/whyDevfest/ezan-thomas-stylized.svg";
import AngieSasmitaPicSvg from "../../assets/whyDevfest/angie-sasmita-stylized.svg";
import CarlosPicSvg from "../../assets/whyDevfest/carlos-reyes-stylized.svg";

const sliderData = [
  {
    id: 1,
    imgSrc: CarlosPicSvg,
    name: "Carlos J. Rojas Reyes, Principal Customer Engineer",
    designation: "Google Latin America",
    whatSaid:
      "DevFest is an amazing opportunity for you to connect with other passionate developers and learn from them!",
    theme: {
      Color: "#34a853",
      backgroundColor: "#f2f9f4",
    },
  },
  {
    id: 2,
    imgSrc: AngieSasmitaPicSvg,
    name: "Angie Sasmita, Android DevRel Engineer",
    designation: "Google Singapore",
    whatSaid:
      "It will feel like a family reunion meeting again with the developer community after years of staring into the screen.",
    theme: {
      Color: "#1967d2",
      backgroundColor: "#fffbf9",
    },
  },
  {
    id: 3,
    imgSrc: ThomasEzanPicSvg,
    name: "Thomas Ezan",
    designation: "Developer Advocate at Google",
    whatSaid:
      "DevFest is the best way to connect with the developer community and learn the latest about APIs and Frameworks!",
    theme: {
      Color: "#d68400",
      backgroundColor: "#fffbf0",
    },
  },
  {
    id: 4,
    imgSrc: AmandaLewisPicSvg,
    name: "Amanda Lewis",
    designation: "Developer Advocate at Google",
    whatSaid:
      "A developer should attend DevFest this year to connect with others and for opportunities to expand their view of software delivery.",
    theme: {
      Color: "#dc362e",
      backgroundColor: "#fffbf9",
    },
  },
];

export default sliderData;
